import imageDrop from "../extensions/image_drop"
import linkConverter from "../extensions/link_converter"
import { promptImage } from "../../../prompt_file.js"

const simple = {
  extensions: ["link_converter", "image_drop"],
  toolbarOptions() {
    return {
      container: [
        [{ size: ["small", false, "large"] }], // Font size selector
        [{ color: [] }], // Font color and background highlight
        ["bold", "italic", "underline"], // B, I, U buttons
        ["clean"],
        ["link", { image: "0" }],
      ],
      handlers: {
        image: (_value) => this.inline(),
      },
    }
  },

  async inline() {
    const file = await promptImage()
    if (!file) return
    const module = this.getModules().imageDropAndPaste
    await module.insertImage(file)
  },
}

export default Object.assign({}, simple, linkConverter, imageDrop)
